import configJson from "./config.json";

export function getConfig() {

  return {
    apiOrigin: configJson.apiOrigin,
  };
}
